import { Grid, Paper } from "@material-ui/core";
import React from "react";
import TeacherManageTable from "../../components/TeacherManagement/TeacherManageTable";

export default function TeacherManagement() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={0}>
                <Grid item xs={12} className="mb-3">
                    <h4>Teacher List</h4>
                </Grid>
                <Grid item xs={12}>
                    <TeacherManageTable />
                </Grid>
            </Grid>
        </Paper>
    );
}
